import { render, staticRenderFns } from "./TaxonItem.vue?vue&type=template&id=7de13878&"
import script from "./TaxonItem.vue?vue&type=script&lang=js&"
export * from "./TaxonItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports